<template>
    <div class="form-group">
        <ValidationProvider
            :vid="'vp' + name"
            tag="div"
            class="w-100"
            :rules="rules"
            :name="name || label"
            v-slot="{ errors, required, classes }"
        >
            <input
                class="custom-control-input"
                :class="classes"
                :id="name"
                :type="type"
                :value="inputVal"
                v-model="innerValue"
            />

            <label class="custom-control-label text-sixth" :for="name">
                <slot name="label" v-if="!label"></slot>
                <span v-else>{{ label }}</span>

                <b class="text-danger">{{ required ? "*" : "" }}</b>
                <slot name="subnote"></slot>
            </label>

            <span class="invalid-feedback" v-if="displayErrors">{{ errors[0] }}</span>
        </ValidationProvider>
    </div>
</template>

<script>
export default {
    name: "ValidationCheckbox",
    props: {
        name: {
            type: String,
            default: "",
        },
        index: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        rules: {
            type: [Object, String],
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
        },
        type: {
            type: String,
            default: "checkbox",
            validator(value) {
                return ["checkbox", "radio"].includes(value);
            },
        },
        value: {
            type: null,
            default: "",
        },
        inputVal: {
            type: null,
            default: "",
        },
        displayErrors: {
            type: Boolean,
            default: true,
        }
    },
    data: () => ({
        innerValue: "",
    }),
    watch: {
        innerValue(value) {
            this.$emit("input", value);
        },
        value(val) {
            if (val !== this.innerValue) {
                this.innerValue = val;
            }
        },
    },
    created() {
        if (this.value) {
            this.innerValue = this.value;
        }
    },
};
</script>
